// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete[data-v-9304f3c2] {\n  color: #4e5a6a;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.delete[data-v-9304f3c2]:hover {\n  color: #2c333a;\n}\n", ""]);
// Exports
module.exports = exports;
